import React from 'react'
import styled from '@emotion/styled'

const BlogPostIndexLayout = ({ headingTexts = [] }) => (
  <IndexListStyle>
    {headingTexts.map((text, index) => (
      <ListItem key={index}>
        <a href={`#${index + 1}`}>
          {index + 1}. {text}
        </a>
      </ListItem>
    ))}
  </IndexListStyle>
)

const IndexListStyle = styled.ul`
  list-style: none;
  background-color: #eff7fc;
  padding: 20px;
  &::before {
    content: '目次';
    display: inline-block;
    margin-bottom: 0.5em;
    font-weight: bold;
    color: #22475d;
  }
`

const ListItem = styled.li`
  color: #22475d;
  font-weight: bold;
`

export default BlogPostIndexLayout
